// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".establishment-tile{color:#1a1a1a;font-size:20px}.establishment-tile .address{color:#bcbcbc;font-size:18px}.establishment-tile .address .detail{font-size:16px;font-style:italic}.establishment-tile .sheet-count a{cursor:pointer;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
